import axios from "axios";
import { getCookie, deleteCookie } from "../helper/cookieHelper";
import { ACCESS_TOKEN, USER_DETAILS, USER_ID, SESSION_ERROR_SHOWN } from "./constants";
import { Store } from "./configureStore";
import { setSignupPopup } from "./features/navigation/navigationActions";
import { removeauthInfo } from "./features/auth/AuthActions";
// import { showErrorToast } from "./utils/toastUtils";
import { showErrorToast, showErrorToastDesktop } from "./utils/toastUtils";
const accessToken = getCookie("ACCESS_TOKEN");
// console.log("accessToken 6", accessToken);

// Helper function to check if session error has been shown
const hasSessionErrorBeenShown = (): boolean => {
  return sessionStorage.getItem(SESSION_ERROR_SHOWN) === "true";
};

// Helper function to mark session error as shown
const markSessionErrorAsShown = (): void => {
  sessionStorage.setItem(SESSION_ERROR_SHOWN, "true");
};

// Helper function to reset session error flag (call on successful login)
export const resetSessionErrorFlag = (): void => {
  sessionStorage.removeItem(SESSION_ERROR_SHOWN);
};
const API = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 60000,
  headers:{
    "X-App-Version": "v2", // or "v2"
  }
  // headers:{'ngrok-skip-browser-warning': 'true'},
});

// ✅ Request Interceptor
API.interceptors.request.use((config) => {
  const token = getCookie("ACCESS_TOKEN"); // Token fetched at request time
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API?.interceptors?.response?.use(
  (res) => res,
  (err) => {
    if (err?.response) {
      switch (err?.response?.status) {
        case 401:
          // Check if we've already shown the error (first time only)
          const hasShown401 = hasSessionErrorBeenShown();
          if (!hasShown401) {
            // Toast for 401 error
            const state401 = Store.getState() as any | undefined;
            const navigationState401 = state401?.navigation as any;
            const isMobile401 = navigationState401?.isMobile;
            const message401 = "Session expired. Please sign in again.";
            if (isMobile401) {
              showErrorToast(message401);
            } else {
              showErrorToastDesktop(message401);
            }
            // Mark as shown
            markSessionErrorAsShown();
          }
          // Delete cookies on 401
          deleteCookie(USER_DETAILS);
          deleteCookie(USER_ID);
          deleteCookie(ACCESS_TOKEN);
          
          // Clear auth state to prevent auto-close issues
          Store.dispatch(removeauthInfo());
          
          // Dispatch Redux action to show Signupnew (only first time)
          if (!hasShown401) {
            // Use setTimeout to ensure state update happens after current execution
            setTimeout(() => {
              Store.dispatch(setSignupPopup(true));
            }, 0);
          }
          
          // Don't navigate - let the Signupnew show on current page
          // The global component will handle showing it everywhere
          
          return err?.response;
        case 403:
          // Check if we've already shown the error (first time only)
          const hasShown403 = hasSessionErrorBeenShown();
          if (!hasShown403) {
            // Toast for 403 error
            const state = Store.getState() as any | undefined;
            const navigationState = state?.navigation as any;
            const isMobile = navigationState?.isMobile;
            const message = "Session expired. Please sign in again.";
            if (isMobile) {
              showErrorToast(message);
            } else {
              showErrorToastDesktop(message);
            }
            // Mark as shown
            markSessionErrorAsShown();
          }
          // Delete cookies on 403
          deleteCookie(USER_DETAILS);
          deleteCookie(USER_ID);
          deleteCookie(ACCESS_TOKEN);
          
          // Clear auth state to prevent auto-close issues
          Store.dispatch(removeauthInfo());
          
          // Dispatch Redux action to show Signupnew (only first time)
          if (!hasShown403) {
            // Use setTimeout to ensure state update happens after current execution
            setTimeout(() => {
              Store.dispatch(setSignupPopup(true));
            }, 0);
          }
          
          // Don't navigate - let the Signupnew show on current page
          // The global component will handle showing it everywhere
          
          return err?.response;
        case 409:
          return err?.response;
        case 400:
          return err?.response;
        case 500:
          return err?.response;
        default:
          break;
      }
    } else {
      console.error("API ERROR:", err);
    }
    throw err;
  }
);

export default API;
